module.exports = __webpack_public_path__ + "img/ico_mas.5e6a0992.svg";